jQuery( document ).ready( function ( $ ) {
	function EXPANDER( thisInstance ) {
		console.log( '[JTF Gut Block - JS] jtf/jtf-expander v1.0' )
		this.instance = thisInstance
		this.init()
	}

	EXPANDER.prototype.init = function () {
		const self = this

		const classExpanderBlock = "jtf__expanderblock"
		const classStringHeader = "__header"
		const classStringContent = "__content"
		const classStringToggle = '--toggle'
		const classStringExpand = '--expand'

		$( self.instance ).on( 'click', '.' + classExpanderBlock + classStringHeader + classStringToggle, function () {
			const contentElem = $( self.instance ).find( '.' + classExpanderBlock + classStringContent )
			const toggleElem = $( self.instance ).find( '.' + classExpanderBlock + classStringHeader + classStringToggle )
			const classExpand = classExpanderBlock + classStringContent + classStringExpand
			const animationTime = 500 // 0.5 second

			if ( contentElem.hasClass( classExpand ) ) {
				contentElem.slideUp(
					animationTime,
					function () {
						toggleElem.find( 'span i' ).removeClass( 'fa-circle-minus' ).addClass( 'fa-circle-plus' )
						toggleElem.attr( 'aria-expanded', false )
						contentElem.removeClass( classExpand )
					},
				)
			} else {
				contentElem.slideDown(
					animationTime,
					function () {
						toggleElem.find( 'span i' ).removeClass( 'fa-circle-plus' ).addClass( 'fa-circle-minus' )
						toggleElem.attr( 'aria-expanded', true )
						contentElem.addClass( classExpand )
					},
				)
			}
		} )
	}

	if ( $( '.wp-admin' ).length > 0 ) {
		setTimeout( function () {
			new EXPANDER( $( this ) )

			if ( $( '.wp-block-jtf-jtf-expander' ).length > 0 ) {
				$( '.wp-block-jtf-jtf-expander' ).each(
					function () {
						new EXPANDER( $( this ) )
					},
				)
			}
		}, 1000 )
	} else {
		// wrap this in a check to see if the outer container even exists,
		// because that way we don't instntiate the code for this if its
		// not on the page
		if ( $( '.wp-block-jtf-jtf-expander' ).length > 0 ) {
			$( '.wp-block-jtf-jtf-expander' ).each(
				function () {
					new EXPANDER( $( this ) )
				},
			)
		}
	}
} )
